module.exports = __webpack_public_path__ + "img/service-sec01-img05.5b7663d5.png";